export const HaveNitrateMedication = 'HaveNitrateMedication';
export const HaveAttentionFollowConsultation = 'HaveAttentionFollowConsultation';
export const EvaluationQuestions = 'EvaluationQuestions';